import React, { useState, useEffect } from 'react';
import { View, Text } from 'react-native';
import { useTranslation } from '@oolio-group/localization';
import DocketContinueStyles from './DocketItemContinue.styles';
import { headerColorSubject } from './DocketItemTimer';
import { Subscription } from 'rxjs';
import { map, distinctUntilChanged } from 'rxjs/operators';
import { useColors } from '../../../hooks/useColors';
import { DocketStatus } from '@oolio-group/domain';
export interface DocketItemBaseProps {
  docketId: string;
  text: string;
  subtext: string;
  status?: DocketStatus;
  orderNumber?: string;
}

const DocketItemHeader: React.FC<DocketItemBaseProps> = ({
  docketId,
  text,
  subtext,
  orderNumber,
  status,
}) => {
  const { translate } = useTranslation();
  const styles = DocketContinueStyles();
  const { colors } = useColors();

  const [milestoneColor, setMilestoneColor] = useState<string | undefined>(
    () => headerColorSubject.getValue()[docketId],
  );

  useEffect(() => {
    const sub: Subscription = headerColorSubject
      .pipe(
        map(colors => colors[docketId]),
        distinctUntilChanged(),
      )
      .subscribe(setMilestoneColor);

    return () => sub.unsubscribe();
  }, [docketId]);

  return (
    <View
      testID="docket-continue"
      style={[
        styles.container,
        {
          backgroundColor:
            status === DocketStatus.CREATED
              ? milestoneColor || colors.accent
              : colors.accent,
        },
      ]}
    >
      <View style={styles.accentBar} />
      <View style={styles.orderNumberContainer}>
        <Text style={styles.orderNumberText}>
          {orderNumber || translate(`kitchenDisplay.${text}`)}
        </Text>
      </View>
      <Text style={styles.positionText}>{subtext}</Text>
    </View>
  );
};

export default React.memo(DocketItemHeader);
